class Registry {
  entries = {};

  constructor(type) {
    if (type === 'model') {
      this.staticProp = 'ModelProps';
    } else if (type === 'app') {
      this.staticProp = 'AppProps';
    }
  }

  add(konstructor) {
    if (typeof konstructor !== 'string') {
      if (konstructor.registryName === undefined) {
        throw Error(
          `class '${konstructor.name}' does not have a registryName but is added to the Registry`,
        );
      }
      /* The below guard would be useful for debugging, but since everything is re-registered on fast-refresh,
      it simply polutes the console log. Ideally we would reset the Registry on fast-refreshing.
    
      if (this.entries[konstructor.registryName]) {
        console.error(
          `adding duplicate constructor '${konstructor.registryName}' to the registry from class '${konstructor.name}'`
        );
      } */
      this.entries[konstructor.registryName] = konstructor;
    } else {
      throw Error(
        `Invalid item "${konstructor}" added to the registry via ${this.staticProp}`,
      );
    }
  }

  get(string) {
    const entry = this.entries[string];
    if (entry === undefined) {
      throw Error(
        `Invalid registry look up. '${string}' does not exist in Registry.`,
      );
    }
    return entry;
  }

  resolve = () => {
    // eslint-disable-next-line no-restricted-syntax
    for (const appName of Object.keys(this.entries)) {
      const app = this.entries[appName];
      const staticProp = app[this.staticProp];
      if (staticProp) {
        // eslint-disable-next-line no-restricted-syntax
        for (const refName of Object.keys(staticProp)) {
          if (typeof staticProp[refName] === 'string') {
            const konstructor = this.entries[staticProp[refName]];
            if (konstructor === undefined) {
              // eslint-disable-next-line no-throw-literal
              throw `Cannot resolve '${staticProp[refName]}' on '${app
                .constructor.registryName || app.constructor.name}'`;
            }
            staticProp[refName] = konstructor;
          } else if (Array.isArray(staticProp[refName])) {
            // eslint-disable-next-line no-restricted-syntax
            for (const [index, ref] of staticProp[refName].entries()) {
              if (typeof ref === 'string') {
                const arrayConstructor = this.entries[ref];
                if (arrayConstructor === undefined) {
                  // eslint-disable-next-line no-throw-literal
                  throw `Cannot resolve '${staticProp[refName]}' on '${app
                    .constructor.registryName || app.constructor.name}'`;
                }
                staticProp[refName][index] = arrayConstructor;
              }
            }
          }
        }
      }
    }
  };
}

export const basicRegistry = function() {
  const reg = {};
  const add = function(key, value) {
    this[key] = value;
  }.bind(reg);
  const get = function(key) {
    return this[key];
  }.bind(reg);
  Object.defineProperty(reg, 'add', { enumerable: false, value: add });
  Object.defineProperty(reg, 'get', { enumerable: false, value: get });
  return reg;
};

export const AppRegistry = new Registry('app');
export const ModelRegistry = new Registry('model');
export const QueryRegistry = basicRegistry();
export const ComponentRegistry = basicRegistry();
export const StoreRegistry = basicRegistry();
export const FieldStoreRegistry = basicRegistry();
